export const headerStyle = {
  backgroundColor: "#fff",
  display: "flex",
  width: "100%",
  alignItems: "center",
  borderBottom: "1px solid #f0f0f0",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
};

const LANGUAGE_OPTIONS = {
  en: { flagClass: "fi fi-gb", name: "English" },
  ca: { flagClass: "fi fi-es-ct", name: "Català" },
  es: { flagClass: "fi fi-es", name: "Español" },
};

export const languageOption = (value) => ({
  value,
  label: (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
      aria-label={LANGUAGE_OPTIONS[value]?.name || value}
    >
      <span className={LANGUAGE_OPTIONS[value]?.flagClass || ""} style={{ fontSize: "1rem" }} />
      <span style={{ fontSize: "0.75em", opacity: 0.75 }}>{value.toUpperCase()}</span>
    </span>
  ),
});
